const ID_NUMBER_VALIDATOR_WEIGHTS = [
    '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
    'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
    'U', 'V', 'W', 'X', 'Y', 'Z',
];

const ID_NUMBER_IMPORTANCES = [7, 3, 1, 0, 7, 3, 1, 7, 3];


/**
 * Walidacja numeru dowodu osobistego
 * @param number
 * @return {boolean}
 */
export const validateIdentityNumber = number => {
    number = String(number).toUpperCase();
    if (number.length !== 9) {
        return false;
    }

    let checkSum = 0;
    let char, weight;
    for (let i = 0; i < 9; i++) {
        char = number[i];
        weight = ID_NUMBER_VALIDATOR_WEIGHTS.indexOf(char);

        if (i < 3 && weight < 10) {
            return false;
        }

        if (i > 2 && weight > 9) {
            return false;
        }

        checkSum += weight * ID_NUMBER_IMPORTANCES[i];
    }
    checkSum %= 10;
    return checkSum === Number(number[3]);
};


const VERIFICATOR_NIP = [6, 5, 7, 2, 3, 4, 5, 6, 7];

/**
 * Walidacja numeru NIP
 * @param value
 * @returns {boolean}
 * @constructor
 */
export const validateNipNumber = value => {
    var nip = value.replace(/[\ \-]/gi, '');
    if (nip.length !== 10) {
        return false;
    } else {
        var n = 0;
        for (var i = 0; i < 9; i++) {
            n += nip[i] * VERIFICATOR_NIP[i];
        }
        n %= 11;
        if (n !== Number(nip[9])) {
            return false;
        }
    }
    return true;
};


/**
 * Waliduje numer REGON
 * @param {string} value
 * @return {boolean}
 */
export const validateRegonNumber = value => {
    const regon = String(value).replace(/[\ \-]/gi, '');
    if (regon.length !== 9) {
        return false;
    }
    const arrSteps = [8, 9, 2, 3, 4, 5, 6, 7];
    let intSum = 0;
    for (let i = 0; i < 8; i++) {
        intSum += arrSteps[i] * regon[i];
    }
    const intb = intSum % 11;
    const intControlNr = (intb === 10) ? 0 : intb;

    return intControlNr === Number(regon[8]);
};


/**
 * Waliduje numer PESEL
 * @param {string} pesel
 * @return {boolean}
 */
export const validatePeselNumber = pesel => {
    const reg = /^[0-9]{11}$/;
    if (reg.test(pesel) === false) {
        return false;
    } else {
        let dig = ("" + pesel).split("");
        let kontrola = (1 * parseInt(dig[0]) + 3 * parseInt(dig[1]) + 7 * parseInt(dig[2]) + 9 * parseInt(dig[3]) + 1 * parseInt(dig[4]) + 3 * parseInt(dig[5]) + 7 * parseInt(dig[6]) + 9 * parseInt(dig[7]) + 1 * parseInt(dig[8]) + 3 * parseInt(dig[9])) % 10;
        if (kontrola === 0) {
            kontrola = 10;
        }
        kontrola = 10 - kontrola;
        return parseInt(dig[10]) === kontrola;
    }
};


/**
 * Waliduje kod pocztowy
 * @param {string} src
 * @return {boolean}
 */
export const validatePostalCode = src => {
    var regex = /^[0-9]{2}\-[0-9]{3}$/;
    return regex.test(src);
};


const BANK_NUMBER_WEIGHTS = [1, 10, 3, 30, 9, 90, 27, 76, 81, 34, 49, 5, 50, 15, 53, 45, 62, 38, 89, 17, 73, 51, 25, 56, 75, 71, 31, 19, 93, 57];

/**
 * Waliduje numer konta bankowego
 * @param bankBumber
 * @return {boolean}
 */
export const validateBankNumber = bankBumber => {
    bankBumber = bankBumber.replace(/[^0-9]+/g, '');
    if (bankBumber.length === 26) {
        bankBumber = bankBumber + "2521";
        bankBumber = bankBumber.substr(2) + bankBumber.substr(0, 2);
        let Z = 0;
        for (let i = 0; i < 30; i++) {
            Z += bankBumber[29 - i] * BANK_NUMBER_WEIGHTS[i];
        }
        return Z % 97 === 1;
    } else {
        return false;
    }
};


/**
 * @param {String} phoneNumber
 * @returns {boolean}
 */
export const validatePhoneNumber = phoneNumber => {
    return String(phoneNumber)
        .replace(/\D/g, '')
        .match(/^\d{9}$/) !== null;
};


/**
 * Proste sprawdzenie adresu email
 * @param email
 * @returns {boolean}
 */
export const validateEmail = email => {
    email = String(email).trim();
    if (email.length === 0) {
        return false;
    }
    return new RegExp(/^[a-zA-Z0-9._-]+@([a-zA-Z0-9.-]+\.)+[a-zA-Z0-9.-]{2,8}$/).test(email);
}

